import { render } from "./RequiredList.vue?vue&type=template&id=e55d2928"
import script from "./RequiredList.vue?vue&type=script&lang=js"
export * from "./RequiredList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__